var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9992 100C22.4295 100 0 77.5697 0 49.9992C0 22.4295 22.4295 0 49.9992 0C77.5688 0 99.9984 22.4295 99.9984 49.9992C99.9984 77.5697 77.5688 100 49.9992 100ZM49.9992 4.93137C25.1492 4.93137 4.93137 25.1492 4.93137 49.9992C4.93137 74.85 25.1492 95.0686 49.9992 95.0686C74.8492 95.0686 95.067 74.85 95.067 49.9992C95.067 25.1492 74.8492 4.93137 49.9992 4.93137Z",
    fill: "#35A171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.835 82.5472C41.5824 82.5472 34.8691 76.563 34.8691 69.207H39.8005C39.8005 73.8442 44.302 77.6158 49.835 77.6158C55.3672 77.6158 59.8679 73.8433 59.8679 69.207H64.7993C64.7993 76.5622 58.086 82.5472 49.835 82.5472Z",
    fill: "#35A171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1198 54.4244H33.1885C33.1885 49.9558 30.1499 46.3205 26.4144 46.3205C22.6789 46.3205 19.6404 49.9558 19.6404 54.4244H14.709C14.709 47.2361 19.9601 41.3892 26.4144 41.3892C32.8688 41.3892 38.1198 47.2361 38.1198 54.4244Z",
    fill: "#35A171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2878 54.4244H80.3565C80.3565 49.9558 77.3179 46.3205 73.5824 46.3205C69.8469 46.3205 66.8083 49.9558 66.8083 54.4244H61.877C61.877 47.2361 67.128 41.3892 73.5824 41.3892C80.0367 41.3892 85.2878 47.2361 85.2878 54.4244Z",
    fill: "#35A171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.29e45aea46d5f0e57884e5a3350d5cfb.svg";
export { ForwardRef as ReactComponent };